import styled from "styled-components";
import { SwiperHorizontal } from "@molecules";

export const StyledSwiperHorizontal = styled(SwiperHorizontal)`
  &.swiper > div.swiper-wrapper {
    padding: 20px 0 20px;
  }
`;
